import axios from 'axios';
import Notification from 'dorothy/utils/alert';

const callApi = (method, url, data = {}) => {
  const token = sessionStorage.getItem('token');

  const config = {
    method,
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    timeout: 0, // No timeout
    data,
  };

  axios.interceptors.response.use(
    response => response,
    error => {
      if (error && error.response && error.response.status === 401) {
        sessionStorage.removeItem('token');
        window.location.href = '/';
      }

      if (error && error.response && error.response.status === 400) {
        throw error.response.data;
      }

      if (typeof error === 'string') throw error;

      const errorMessage = error.response?.data?.message || error.message;
      if (errorMessage && typeof errorMessage == 'string') {
        Notification.error(errorMessage);
      }
      throw error.response || error;
    },
  );

  return axios(config).then((response, error) => {
    if (error) return error;
    return response.data;
  });
};

export default callApi;
